export const availableItemFieldsForList = [
  {
    name: "checked",
    type: "checkbox",
    width: 1,
    visible: true
  },
  {
    name: "id",
    hederName: "PROJECTS.TYPES.TYPE_NUMBER",
    type: "text",
    width: 3,
    visible: true
  },
  {
    name: "name",
    hederName: "PROJECTS.TYPES.TYPE_NAME_PLACEHOLDER",
    type: "text",
    width: 3,
    searchable: true,
    disabled: true,
    visible: true
  },
  {
    name: "description",
    hederName: "PROJECTS.TYPES.TYPE_DESCRIPTION_ONLY",
    type: "text",
    width: 5,
    searchable: true,
    disabled: true,
    visible: true
  },
  {
    name: "operations",
    hederName: "SETTINGS.HEADERS.OPERATION",
    type: "iconGroup",
    visible: true,
    icons: [
      {
        name: "edit",
        type: "icon",
        operation: "edit",
        width: 1,
        popupText: "PROJECTS.TYPES.EDIT_TYPE"
      },
      {
        name: "archive",
        type: "icon",
        operation: "archive",
        width: 1,
        popupText: "SETTINGS.ICONS.ARCHIVE"
      },
      {
        name: "trash alternate",
        type: "icon",
        operation: "delete",
        width: 1,
        popupText: "PROJECTS.TYPES.DELETE_TYPE"
      }
    ]
  }
];

export const availableItemFieldsForArchive = [
  {
    name: "checked",
    type: "checkbox",
    width: 1
  },
  {
    name: "id",
    hederName: "PROJECTS.TYPES.TYPE_NUMBER",
    type: "text",
    width: 3
  },
  {
    name: "name",
    hederName: "PROJECTS.TYPES.TYPE_NAME_PLACEHOLDER",
    type: "text",
    width: 3
  },
  {
    name: "description",
    hederName: "PROJECTS.TYPES.TYPE_DESCRIPTION_ONLY",
    type: "text",
    width: 5
  }
];

export const leftPanelConfig = [
  { type: "createNew", buttonText: "PROJECTS.TYPES.NEW_TYPE" },
  {
    type: "sectionHeader",
    itemList: [
      {
        type: "filter",
        name: "archived",
        itemText: "CONTACTS.SIDEBAR.ARCHIVE_STATUS_ARCHIVED",
        iconName: "archive"
      }
    ]
  }
];

export const myEmptyType = { name: "", description: "" };
